import { type FC } from 'react'
import { useIntl } from 'react-intl'

import { IconEyeClose, IconEyeOpen } from '@redteclab/icons'

type LoginRegistrationUserLoginShowPasswordProps = {
  showPassword: boolean
  toggleShowPassword: () => void
}

export const LoginRegistrationUserLoginShowPassword: FC<
  LoginRegistrationUserLoginShowPasswordProps
> = ({ showPassword, toggleShowPassword }) => {
  const intl = useIntl()
  const Icon = showPassword ? IconEyeClose : IconEyeOpen

  return (
    <button
      aria-label={intl.formatMessage({
        id: 'general.label.passwordVisibilityToggle',
      })}
      onClick={toggleShowPassword}
      type="button"
    >
      <Icon className="size-8 fill-dark-primary-max" />
    </button>
  )
}
